import React from 'react';

import { connect } from 'react-redux';

import Header from '@/components/global/Header';
import SideBar from '@/components/global/SideBar';
import W9Banner from '@/components/global/W9Banner';
import useCustomScripts from '@/hooks/useCustomScripts';
import { useWidgetScript } from '@/hooks/useWidgetScript';
import { LayoutPropsType, ServerStatus } from '@/models/globalModels';
import { doCustomizeMetaInfo } from '@/redux/customizations/actions';
import { selectMetaCustomization } from '@/redux/customizations/reducers';
import { RootState } from '@/redux/rootReducer';

const mapDispatchToProps = {
  doCustomizeMetaInfo,
};

const mapStateToProps = (state: RootState) => {
  const layout = state.layout;
  const auth = state.auth;
  const customization = state.customizations;
  return {
    layout,
    auth,
    metaCustomization: selectMetaCustomization(state),
    customizationStatus: customization.customizationStatus,
  };
};

const LayoutWrapper = ({
  children,
  layout,
  auth,
  metaCustomization,
  doCustomizeMetaInfo,
  customizationStatus = ServerStatus.IDLE,
  nonce,
  company,
}: LayoutPropsType) => {
  const [mobileSidebarToggler, setMobileSideBarToggler] = React.useState(false);
  React.useEffect(() => {
    if (doCustomizeMetaInfo && customizationStatus == ServerStatus.FETCH) {
      doCustomizeMetaInfo(metaCustomization);
    }
  }, [customizationStatus, doCustomizeMetaInfo]);

  useCustomScripts(company, nonce);
  useWidgetScript({ nonce });

  React.useEffect(() => {
    const affiliateUid = auth.ambassadorProfile?.uid;
    if (typeof window === 'undefined' || !affiliateUid) return;
    try {
      window.localStorage.setItem('uid', String(affiliateUid));
    } catch {
      /* noop — storage disabled */
    }
  }, [auth.ambassadorProfile?.uid]);

  return (
    <div className="LayoutWrapper container-fluid Layout p-0 h-100 overflow-hidden">
      <div className="row m-0 h-100">
        {layout.layoutActive ? (
          <Header mobileSidebarToggler={mobileSidebarToggler} setMobileSideBarToggler={setMobileSideBarToggler} />
        ) : null}

        <div className="MainContent g-0">
          {layout.layoutActive ? (
            <div className="SideBarWrapper d-flex p-0">
              <SideBar
                itemActive={layout.itemActive}
                mobileSidebarToggler={mobileSidebarToggler}
                setMobileSideBarToggler={setMobileSideBarToggler}
              />
              {mobileSidebarToggler && (
                <div className="sideBar-mobile-mask" onClick={() => setMobileSideBarToggler && setMobileSideBarToggler(false)} />
              )}
            </div>
          ) : null}
          <div className="ContentWrapper w-100 p-0 overflow-x-hidden">
            {layout.layoutActive && auth.ambassadorProfile?.uid ? <W9Banner /> : null}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWrapper);
